import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FeaturePointsInputProps {
  featurePoints: string[];
  onChange: (points: string[]) => void;
}

export const FeaturePointsInput = ({ featurePoints, onChange }: FeaturePointsInputProps) => {
  const handleFeaturePointKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && e.currentTarget.value.trim()) {
      e.preventDefault();
      const newPoint = e.currentTarget.value.trim();
      onChange([...featurePoints, newPoint]);
      e.currentTarget.value = '';
    }
  };

  const removeFeaturePoint = (index: number) => {
    const updatedPoints = featurePoints.filter((_, i) => i !== index);
    onChange(updatedPoints);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="featurePoints" className="text-gray-200">Feature Points</Label>
      <Input
        id="featurePoints"
        placeholder="Type a feature point and press Enter"
        onKeyDown={handleFeaturePointKeyDown}
        className="bg-black/30 border-gray-800 text-white placeholder-gray-500"
      />
      {featurePoints.length > 0 && (
        <div className="mt-2 space-y-2">
          {featurePoints.map((point, index) => (
            <div key={index} className="flex items-center gap-2 bg-black/20 p-2 rounded-md">
              <span className="text-white flex-1">{point}</span>
              <button
                onClick={() => removeFeaturePoint(index)}
                className="text-red-400 hover:text-red-300"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};